
import { Templates } from "Enums";
import { useSelectedTemplate } from "hooks";
import Template3FloatingWhatsapp from "Templates/Template3/Components/Common/FloatingWhatsapp";

const FloatingWhatsapp = () => {
    const selectedTemplate = useSelectedTemplate();

    const chooseTemplate = (template: Templates) => {
        switch (template) {
            case Templates.TEMP3:
                return <Template3FloatingWhatsapp />
            default:
                return null;
        }
    }

    return (
        <>
            {chooseTemplate(selectedTemplate)}
        </>
    );
}

export default FloatingWhatsapp;